import { BaseUrlService } from './base-url.service';

export class ConservazioneService {
    static $inject: string[] = ['$http', 'BaseUrlService'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    getMailPecDaVerificareDocuments() {
        return this.$http.get(this.baseUrl + '/conservazione/get-mail-pec/da-verificare');
    }

    getMailPecDaVerificareDocumentIds() {
        return this.$http.get(this.baseUrl + '/conservazione/get-mail-pec/da-verificare-ids');
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/conservazione.service.ts